var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.5C10.4142 4.5 10.75 4.83579 10.75 5.25V15.75C10.75 16.1642 10.4142 16.5 10 16.5C9.58579 16.5 9.25 16.1642 9.25 15.75V5.25C9.25 4.83579 9.58579 4.5 10 4.5Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.5C4 10.0858 4.33579 9.75 4.75 9.75H15.25C15.6642 9.75 16 10.0858 16 10.5C16 10.9142 15.6642 11.25 15.25 11.25H4.75C4.33579 11.25 4 10.9142 4 10.5Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.b79b6795d2e9ef4f47cd174760f4e2f4.svg";
export { ForwardRef as ReactComponent };